export const paymentLinks_PT_BR = {
	title: "Links de pagamento",
	description: "Crie e acompanhe cobranças avulsas do estabelecimento.",
	searchPlaceholder: "Buscar por ID do link",
	createButton: "Nova cobrança",
	empty: "Nenhum link de pagamento criado",
	emptyDescription: "Crie uma nova cobrança para gerar um link de pagamento.",
	copyLink: "Copiar link",
	open: "Abrir",
	linkCopied: "Link copiado para a área de transferência",
	perPage: "página",
	columns: {
		id: "ID do link",
		amount: "Valor",
		installments: "Parcelas",
		status: "Status",
		origin: "Liquidação",
		createdAt: "Criado em",
		actions: "Ações",
	},
	status: {
		PENDING: "Pendente",
		PAID: "Pago",
		EXPIRED: "Expirado",
		CANCELED: "Cancelado",
	},
	origin: {
		zig: "Conta Zig",
		place: "Conta do estabelecimento",
	},
	modal: {
		title: "Nova cobrança",
		amount: "Valor da cobrança",
		amountPlaceholder: "R$ 0,00",
		installments: "Parcelas",
		paymentOrigin: "Conta de liquidação",
		description: "Descrição",
		descriptionPlaceholder: "Descreva a cobrança que o pagador irá visualizar",
		cancel: "Cancelar",
		submit: "Gerar link de pagamento",
		successMessage: "Link de pagamento criado com sucesso",
		requiredField: "Campo obrigatório",
		generatedTitle: "Link de pagamento gerado",
		generatedDescription: "Copie e envie o link para o pagador.",
		copyLink: "Copiar link",
		linkCopied: "Link copiado para a área de transferência",
		done: "Concluir",
	},
};

export type paymentLinksTranslations = typeof paymentLinks_PT_BR;
